import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, Clock, HelpCircle } from 'lucide-react';
const painPoints = [{
  icon: TrendingDown,
  title: 'El peso pierde valor cada día',
  description: 'Tu esfuerzo vale menos con el tiempo'
}, {
  icon: Clock,
  title: 'Trabajas 8+ horas por un sueldo que no alcanza',
  description: 'El modelo tradicional está roto'
}, {
  icon: HelpCircle,
  title: 'Ves a otras ganar en dólares y no sabes cómo',
  description: 'La información está oculta'
}];
export function ProblemSection() {
  return <section className="w-full bg-cream-primary py-16 md:py-24" data-id="element-138">
      <div className="max-w-7xl mx-auto px-6" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-emerald-primary mb-6" data-id="element-141">
            ¿Trabajas el triple pero tu cuenta bancaria no lo refleja?
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed" data-id="element-142">
            La realidad es cruda: El peso colombiano pierde valor, pero tu
            tiempo es oro. Mientras la mayoría intenta "hacerse viral" o vender
            productos baratos, un grupo selecto de mujeres ha descubierto una
            grieta en el sistema.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-143">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.article key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-144">
                <div className="w-16 h-16 bg-emerald-primary/10 rounded-full flex items-center justify-center mb-6" data-id="element-145">
                  <Icon className="w-8 h-8 text-emerald-primary" aria-hidden="true" data-id="element-146" />
                </div>
                <h3 className="text-2xl font-bold text-emerald-primary mb-3" data-id="element-147">
                  {point.title}
                </h3>
                <p className="text-lg text-gray-600" data-id="element-148">{point.description}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}